import { CONSULTATIONS_STATUSES } from '@/configs';
import { CLEAR_PAGE } from '../base/types';
import { CANCEL_CONSULTATION, COMPLETE_CONSULTATION, FETCH_CONSULTATION } from './consultationsActionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  isRejected: false,
  isAuth: false,
};

const consultationsReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_CONSULTATION}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_CONSULTATION}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_CONSULTATION}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isRejected: true,
        isLoading: false,
      };

    case `${COMPLETE_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {...state?.data || {}, status: CONSULTATIONS_STATUSES.provided},
      };

    case `${CANCEL_CONSULTATION}_FULFILLED`:
      if (!state.isLoaded) return state;
      return {
        ...state,
        data: {...state?.data || {}, status:  CONSULTATIONS_STATUSES.canceled},
      };

    case CLEAR_PAGE:
      return payload === 'consultation' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default consultationsReducer;
